// 출제 payload 에 섹션을 만들 재료가 하나라도 들어 있는지 본다.
// 지인에듀가 200 을 주면서 빈 본문을 돌려주면 지문 껍데기만 남은 payload 가 만들어지고,
// 그대로 출제하면 학생이 풀 수 없는 과제가 된다.
// api/assignment/views.py 의 has_section_source_data 와 같은 판정이다.
export const hasSectionSourceData = (paragraphs) => {
  if (!paragraphs) return false;

  // sentence, grammar 는 지문 배열이 아니라 documents 를 담은 객체다.
  if (!Array.isArray(paragraphs)) {
    return (
      (paragraphs.documents?.length ?? 0) > 0 ||
      (paragraphs.sentence_list?.length ?? 0) > 0
    );
  }

  return paragraphs.some((paragraph) => (paragraph?.data?.length ?? 0) > 0);
};

export const getRandom5Sentences = (sentences) => {
  if (sentences.length <= 5) {
    return sentences; // 5개 이하일 경우 전체 리스트 반환
  }

  const startIndex = Math.floor(Math.random() * (sentences.length - 4));
  return sentences.slice(startIndex, startIndex + 5);
};
